// Wspólne klasy pól i przycisków — duże cele dotyku (min. 44 px), text-base zapobiega powiększaniu na iOS.
export const inputCls =
  'w-full rounded-xl border border-stone-300 bg-white px-4 py-3 text-base outline-none focus:border-brand-600 focus:ring-2 focus:ring-brand-600/20 dark:border-stone-700 dark:bg-stone-900';

export const primaryBtn =
  'flex min-h-12 w-full items-center justify-center rounded-xl bg-brand-700 px-4 py-3 font-medium text-white active:bg-brand-800 disabled:opacity-50';

export const secondaryBtn =
  'flex min-h-12 w-full items-center justify-center rounded-xl border border-stone-300 bg-white px-4 py-3 font-medium active:bg-stone-100 disabled:opacity-50 dark:border-stone-700 dark:bg-stone-900 dark:active:bg-stone-800';

export const cardCls = 'rounded-2xl border border-stone-200 bg-white shadow-sm dark:border-stone-800 dark:bg-stone-900';

export const sectionTitleCls = 'px-1 text-sm font-semibold uppercase tracking-wide text-stone-500';
